import { Expose } from 'class-transformer';

export class SnSharePermissionsDetails {
  @Expose()
  public view: boolean;

  @Expose()
  public change: boolean;

  @Expose()
  public delete: boolean;

  @Expose()
  public viewPlayback: boolean;

  @Expose()
  public viewLiveVideo: boolean;

  @Expose()
  public enablePtzControl: boolean;
}
